import React from 'react';
import PropTypes from 'prop-types';
import { AImagePreview, AImagePlaceholder } from '../atoms';

export default function MImagePreview({ items, onClick, isUploading }) {
	const handleClick = (item) => {
		onClick(item);
	};

	return (
		<article className="m-image-preview-list">
			{
				items.map((item, i) => (
					<AImagePreview
						key={`${i}xdImage`}
						img={item.url}
						onClick={() => handleClick(item)}
					/>
				))
			}

			{ isUploading &&
			<section className="o-cms-file-upload o-cms-file-upload--small">
				<AImagePlaceholder loading={isUploading} />
			</section>
			}
		</article>
	);
}

MImagePreview.propTypes = {
	items: PropTypes.array,
	onClick: PropTypes.func,
	isUploading: PropTypes.bool,
};

MImagePreview.defaultProps = {
	items: [],
	onClick: undefined,
	isUploading: false,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.image-preview.js